import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import { PaymentAmount } from "../../shared/PaymentAmount";
import PaymentMethodSelect from "../../shared/PaymentMethodSelect";
import { MerchantButton } from "@components";
import { Controller, useForm } from "react-hook-form";

const EapChooseAmount = () => {
  const { customer, contactId, paymentParameters, setPaymentParameters } = useOutletContext();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");
  const navigate = useNavigate()

  const { control, setValue, watch, formState: { errors, isValid }, handleSubmit } = useForm({
    defaultValues: {
      amount: customer.balance,
    }
  });

  const onConfirm = (data) => {
    setPaymentParameters({ ...paymentParameters, amount: data.amount });
    navigate(`/embeddedaccountpayment/choosemethod?cu=${contactId}`)
  }

  return (paymentParameters && <div className="w-full flex flex-col items-center grow pt-8">
    <div className="mt-2 mb-5">
      <h3 className="text-lg font-semibold">Payment amount</h3>
      <h4 className="text-sm text-zinc-500">Choose the amount you would like to pay</h4>
    </div>
    <form onSubmit={handleSubmit(onConfirm)}>
      <div className="flex items-baseline">
        <span className="text-2xl">£</span>
        <Controller
          name="amount"
          control={control}
          rules={{
            required: "Amount is required",
            min: {
              value: 0.3,
              message: "Amount must be greater than £0.30"
            }
          }}
          render={({ field: { onChange, ...field } }) => (
            <input
              {...field}
              type="number"
              step="0.01"
              placeholder="0.00"
              className="w-full border-0 border-b text-center text-2xl  focus:outline-none"
              onChange={e => {
                // Allow only two decimal places
                const value = e.target.value;
                if (!value || /^\d+(\.\d{0,2})?$/.test(value)) {
                  onChange(value);
                }
              }}
            />
          )}
        />
      </div>
      {errors.amount ? (
        <p className="text-red-500 text-center text-xs my-2">{errors.amount.message}</p>
      ) : (
        <p className="text-transparent text-xs my-2">spacer</p>
      )}
      <MerchantButton merchant={customer.merchant} type="submit">Confirm</MerchantButton>
    </form>
  </div>);
}
export default EapChooseAmount;

